import { cloneDeep, isEmpty } from 'lodash';
import React, { useEffect, useMemo, useState } from 'react';
import styles from './common-master-filters.module.scss';
import {
  ANALYTICS_FILTER_OPTIONS,
  ANALYTICS_FILTER_TITLE,
  DEMOGRAPHIC_DETAIL_FILTERS,
  EMPLOYMENT_INFO_DETAIL_FILTERS,
  SUCCESSION_AND_TOP_TALENT_STATUS_DETAIL_FILTERS,
  USER_ACCESS_MESSAGE,
} from '../../utils/constants';
import { filterCheckedItems } from '../../utils/helper';
import { Arrow_Down_2, Arrow_Up_2, master_filter_icon } from '../../assets/img';
import { talentAnalyticApi } from '../../services/talentAnalyticApi';
import { useSelector } from 'react-redux';
import DropdownMasterTreeSelectCustom from '../DropdownMasterTreeSelectCustom/DropdownMasterTreeSelectCustom';
import Spinner from '../Loading/Spinner';
import { notification } from 'antd';

export const InitMasterFilter = {
  age: [],
  state_of_birth: [],
  current_functional: [],
  gender: [],
  language: [],
  nationality: [],
  current_business: [],
  salary_grade: [],
  year_to_retire: [],
  work_location: [],
  successor: [],
  top_talent_status: [],
  critical_position_category: [],
};

const CommonMasterFilters = (props) => {
  const { setFilterFinderData, filterFinderData } = props;
  const { roleId } = useSelector((state) => state.user.roleActive);

  const [filterOptions, setFilterOptions] = useState(InitMasterFilter);
  const [prevFilterOptions, setPrevFilterOptions] = useState(InitMasterFilter);
  const [currentFilterActive, setCurrentFilterActive] = useState(null);
  const [showFilters, setShowFilters] = useState(false);
  const [clearFilterName, setClearFilterName] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    async function fetchApiOptions() {
      try {
        setLoading(true);
        const params = {
          is_talent_finder: false,
        };
        const filterRes = await talentAnalyticApi.getAnalyticsFilters(params, roleId);
        if (filterRes && filterRes.status === 200) {
          setFilterOptions(filterRes.data.result);
          setPrevFilterOptions(filterRes.data.result);
        }
      } catch (error) {
        console.error(error);
        notification.error({
          message: USER_ACCESS_MESSAGE.AN_UNEXPECTED_ERROR,
          duration: 5,
        });
      } finally {
        setLoading(false);
      }
    }
    fetchApiOptions();
  }, []);

  const getFilterApplied = useMemo(() => {
    let tempData = {};
    Object.keys(filterFinderData).forEach((key) => {
      if (!isEmpty(filterFinderData[key]) && filterFinderData[key].filter((i) => i.checked)) {
        tempData[key] = filterFinderData[key];
      }
    });
    return tempData;
  }, [filterFinderData, filterOptions]);

  const getDataToPost = (data) => {
    let tempObj = { ...InitMasterFilter };
    Object.keys(ANALYTICS_FILTER_OPTIONS).forEach((key) => {
      tempObj[ANALYTICS_FILTER_OPTIONS[key]] = filterCheckedItems(data[ANALYTICS_FILTER_OPTIONS[key]]);
    });
    return tempObj;
  };

  const getFilterTabActive = useMemo(() => {
    return Object.keys(filterFinderData).filter((f) => filterFinderData[f].length > 0);
  }, [filterFinderData, filterOptions]);

  const handleOnChangeFilter = (key, filterApplied) => {
    const tempData = !isEmpty(filterApplied) ? filterApplied : filterOptions[key];

    const dataToPost = getDataToPost({
      ...cloneDeep(filterOptions),
      [key]: tempData,
    });
    setFilterFinderData(dataToPost);
    setFilterOptions((prev) => {
      return {
        ...prev,
        [key]: tempData,
      };
    });
  };

  const handleClearFilter = () => {
    setFilterFinderData(InitMasterFilter);
    setFilterOptions(prevFilterOptions);
  };

  const dropDownGenerator = (item) => {
    return Object.keys(filterOptions).map((key, index) => {
      if (item.value === key) {
        return (
          <DropdownMasterTreeSelectCustom
            key={`${key}.${index}`}
            label={item.label}
            placeholder={item.label}
            data={filterOptions[key]}
            filterName={key}
            setCurrentFilterActive={setCurrentFilterActive}
            currentFilterActive={currentFilterActive}
            onChangeFilter={handleOnChangeFilter}
            clearFilterName={clearFilterName}
            setClearFilterName={setClearFilterName}
            filterFinderData={filterFinderData}
            getFilterTabActive={getFilterTabActive}
          />
        );
      }
      return null;
    });
  };

  return (
    <div className={styles.filter_section}>
      <div className={styles.filter_section_top}>
        <div className={styles.filter_applied}>
          <div className={styles.filter_applied_title} onClick={() => setShowFilters((prev) => !prev)}>
            <img className={styles.filter_icon} src={master_filter_icon} alt="" />
            Filters
            <img className={styles.up_down_icon} src={showFilters ? Arrow_Up_2 : Arrow_Down_2} alt="" />
          </div>
          {Object.keys(getFilterApplied).length > 0 && (
            <div className={styles.number_filter_applied}>
              <span>{Object.keys(getFilterApplied).length}</span>
              Filters applied
            </div>
          )}
        </div>
        {(showFilters || Object.keys(getFilterApplied).length > 0) && (
          <button
            className={
              Object.keys(getFilterApplied).length > 0 ? `${styles.clear_filter_btn} ${styles.clear_filter_btn_active}` : `${styles.clear_filter_btn}`
            }
            onClick={() => {
              if (Object.keys(getFilterApplied).length > 0) {
                handleClearFilter();
                setClearFilterName('ALL');
              }
            }}
          >
            Clear All Filters
          </button>
        )}
      </div>
      {showFilters && (
        <>
          {loading ? (
            <div className={`filter_section row ${styles.container}`}>
              <div className={styles.flex_center}>
                <Spinner />
              </div>
            </div>
          ) : (
            <div className={`filter_section row ${styles.container}`}>
              <div className={styles.filter_list_wrapper}>
                <div className={styles.filter_title}>{ANALYTICS_FILTER_TITLE.DEMOGRAPHIC}</div>
                <div className={styles.filter_group_wrapper}>
                  {!isEmpty(filterOptions?.age) && DEMOGRAPHIC_DETAIL_FILTERS.map((item) => dropDownGenerator(item))}
                </div>
              </div>
              <div className={styles.filter_list_wrapper}>
                <div className={styles.filter_title}>{ANALYTICS_FILTER_TITLE.EMPLOYMENT_INFO}</div>
                {!isEmpty(filterOptions?.salary_grade) && EMPLOYMENT_INFO_DETAIL_FILTERS.map((item) => dropDownGenerator(item))}
              </div>
              <div className={styles.filter_list_wrapper}>
                <div className={styles.filter_title}>{ANALYTICS_FILTER_TITLE.SUCCESSION_AND_TOP_TALENT_STATUS}</div>
                {!isEmpty(filterOptions?.successor) && SUCCESSION_AND_TOP_TALENT_STATUS_DETAIL_FILTERS.map((item) => dropDownGenerator(item))}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default CommonMasterFilters;
